import script from "./HeaderBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&setup=true&lang=js"

import "./HeaderBlock.vue?vue&type=style&index=0&id=252ffd12&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-252ffd12"]])

export default __exports__